import { AgreementFormValues } from "@modules/agreements/validations/agreementSchema";

export function normalizeVolumetryAgreementFields(data: Partial<AgreementFormValues>) {
  if (!("volumetry_email_day" in data)) return data;

  const day = data.volumetry_email_day;
  if (day === "" || day === undefined || day === null) {
    data.volumetry_email_day = null;
  } else {
    data.volumetry_email_day = Number(day);
  }

  return data;
}
